import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { API_MODE } from "./env";
import "./styles/tokens.css";
import "./styles/tiles.css";
import "./styles/global.css";

async function boot() {
  // The one switch between mock and live: VITE_API_MODE (default "mock").
  if (API_MODE === "mock") {
    const { startMockApi } = await import("./mocks/browser");
    await startMockApi();
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
